<template>
    <div>
        <SortableList title="Produtos"
            ref="organizer"
            @add="goToProductAdd"
            @selected="setSelected"
            :saveOrderPromise="saveOrder"
            :disableAdd="!selectedProductType"
            noSelect
            :busy.sync="busy"/>
        
        <AddEditModal v-if="selectedMenuId"
            :pTypeData="modalFrmAddEdit.productType"
            :menuID="selectedMenuId"
            :lastOrderNumber="totalItems || 0"
            :visible.sync="modalFrmAddEdit.visible"
        />
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase';
    import SortableList from './SortableList';

    let db = firebase.firestore();

    export default {
        components: {
            SortableList,
        },
        props: {
            selectedProductType: Object,
            selectedMenuId: String
        },

        watch: {
            busy (val) {
                if (val)
                    this.$refs.organizer.wipeOrder(); // to reset state after a operation
            },
            selectedProductType (val) {
                this.$refs.organizer.clear();
                if (val)
                    Object.values(val.products).forEach(p => this.$refs.organizer.onChange(p));
            }
        },
        data () {
            return {
                busy: false
            }
        },
        methods: {
            setSelected (item) {
                this.$emit('selected', item);
            },
            async saveOrder (list) {
                let companyId = this.$store.getters.getCompanyID

                const updObj = {};
                list.filter((m, i) => m.order !== i).forEach((item) => {
                    const index = list.findIndex(m => item.id === m.id);
                    updObj[`products.${item.id}.order`] = index;
                });
                await db.collection('company').doc(companyId)
                        .collection('productType').doc(this.selectedProductType.id)
                        .update(updObj);
            },
            goToProductAdd () {
                this.$router.push(`add?menuId=${this.selectedProductType.menu}&productTypeId=${this.selectedProductType.id}`)
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>